import { render } from "./MiNTNewsDetail.vue?vue&type=template&id=4da07c5b&scoped=true"
import script from "./MiNTNewsDetail.vue?vue&type=script&lang=js"
export * from "./MiNTNewsDetail.vue?vue&type=script&lang=js"

import "./MiNTNewsDetail.vue?vue&type=style&index=0&id=4da07c5b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da07c5b"]])

export default __exports__